import axios from 'axios';
import { FishGroup } from '../types/fish-group.type';

// GET
// /ewosapi/v1/planandprognosis/site/{globalSiteId}/fishgroup/inactive/{generation}
export const getHarvestedFishGroups = async (globalSiteId: string): Promise<FishGroup[]> => {
  const generations = await getFishGroupGenerations(globalSiteId);

  const res = await axios.all(
    generations.map((generation) =>
      axios
        .get<FishGroup[]>(`/ewosapi/v1/planandprognosis/site/${globalSiteId}/fishgroup/inactive/${generation}`)
        .then((resp) => resp.data)
    )
  );
  return res.flat();
};

// GET
// /ewosapi/v1/planandprognosis/site/{globalSiteId}/fishgroup/inactive/generations
export const getFishGroupGenerations = async (globalSiteId: string): Promise<number[]> => {
  const res = await axios.get<number[]>(`/ewosapi/v1/planandprognosis/site/${globalSiteId}/fishgroup/inactive/generations`);
  return res.data;
};
